import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiAlertCircle } from 'react-icons/fi';

const EditArticle = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/dashboard/articles');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      className="min-h-screen bg-gray-900 p-8"
    >
      <div className="max-w-2xl mx-auto">
        <button
          onClick={handleBack}
          className="inline-flex items-center px-4 py-2 bg-gray-800/50 text-white rounded-xl hover:bg-gray-800 transition-colors mb-8"
        >
          <FiArrowLeft className="w-5 h-5 mr-2" />
          Back to Articles
        </button>
        
        <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl border border-white/5 p-8 text-center">
          <FiAlertCircle className="w-16 h-16 text-yellow-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-white mb-2">Feature Coming Soon</h2>
          <p className="text-gray-400">
            Article editing is being migrated to the new system. This feature will be available soon.
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default EditArticle;
